<template>
  <div class="container" v-if="currentDate != null">
    <div class="row align-content-center justify-content-center text-center px-3">
      <m-icon icon="arrow-right-circle" class="cursor-pointer h4" :class="{'d-none':previewsDayButtonStatus()}"
              @click="changeSelectedMonth('down')"/>
      <div class="col">{{ currentDateString() }}</div>
      <m-icon icon="arrow-left-circle" class="cursor-pointer h4" @click="changeSelectedMonth('up')"/>
    </div>
  </div>
</template>

<script>
import mIcon from "../../Icons/Icon.vue";
import {gregorian_to_jalali, jalali_to_gregorian} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/jalali";

export default {
  name: "ReservationDaySelector",
  components: {mIcon},
  props: {
    product: {}
  },
  data() {
    return {
      currentDate: null
    }
  },
  computed: {},
  methods: {
    changeSelectedMonth(mode = 'up') {
      if (mode === 'up') {
        this.currentDate = this.findActiveDayOfTheWeek('up')
        this.emitCurrentDate();
      }
      if (mode === 'down') {
        this.currentDate = this.findActiveDayOfTheWeek('down')
        this.emitCurrentDate();
      }
      this.$forceUpdate()
    },
    currentDateString() {
      return this.currentDate.toLocaleDateString('fa-IR-u-nu-latn', {weekday: 'long', day: 'numeric', month: 'short'})
    },
    emitCurrentDate() {
      this.$emit('day', this.currentDate)
    },
    previewsDayButtonStatus() {
      const selectedDate = this.currentDate.toLocaleString('en-us', {year: "numeric", month: 'numeric', day: "2-digit"})
      const currentDate = new Date().toLocaleString('en-us', {year: "numeric", month: 'numeric', day: "2-digit"})
      return (selectedDate === currentDate)
    },
    convertOffTimesToGregory(value) {
      value = value.split(' ')
      let date = value[0].split('/')
      let time = `${value[1]}:00`
      date = jalali_to_gregorian(parseInt(date[0]), parseInt(date[1]), parseInt(date[2])).join('-')
      let result = `${date} ${time}`
      return result
    },
    findActiveDayOfTheWeek(mode = 'init') {
      let currentDate = this.currentDate
      let currentDateIndex = currentDate.getDay()
      let rawReservationRules = this.product.reservation_rules;
      let reservationRules = JSON.parse(rawReservationRules.json);
      let work_times = reservationRules.work_times;
      let off_times = reservationRules.off_times;

      let offRanges = off_times.map(range => {
        let start = this.convertOffTimesToGregory(range[0]);
        let end = this.convertOffTimesToGregory(range[1]);

        return [new Date(start), new Date(end)];
      });

      for (let i = 0; i < 200; i++) {
        if (mode === 'up') {
          currentDate.setDate(currentDate.getDate() + 1)
        }
        if (mode === 'down') {
          currentDate.setDate(currentDate.getDate() - 1)
        }
        currentDateIndex = currentDate.getDay()
        if (work_times[currentDateIndex].length > 0) {
          // بررسی اینکه این روز در هیچ بازه تعطیلی نباشد
          let isInOffTime = offRanges.some(([start, end]) => {
            return currentDate >= start && currentDate <= end;
          });

          if (!isInOffTime) {
            return new Date(currentDate); // پیدا کردیم
          }
        }
      }

      return currentDate
    }
  },
  beforeMount() {

    setTimeout(() => {

      this.currentDate = new Date()
      this.currentDate.setDate(this.currentDate.getDate() - 1); // یک روز کم می‌کنیم
      this.currentDate = this.findActiveDayOfTheWeek('up')
      this.emitCurrentDate();

    }, 100)

  }
}
</script>


<style scoped>

</style>